import { Link } from 'react-router';
import { Card } from '../../components/Card';
import { SkyPage } from '../../components/SkyPage';
import { da } from '../../i18n/da';
import styles from './ParentsPage.module.css';

/** For parents: what PixelWorld is, how chat works and what is stored. Open without login. */
export function ParentsPage() {
  return (
    <SkyPage>
      <Card className={styles.card} aria-labelledby="parents-title">
        <h2 id="parents-title" className={styles.title}>
          {da.parents.title}
        </h2>
        <p>{da.parents.intro}</p>
        {da.parents.sections.map((section) => (
          <section key={section.heading} className={styles.section}>
            <h3 className={styles.heading}>{section.heading}</h3>
            <ul className={styles.list}>
              {section.lines.map((line) => (
                <li key={line}>{line}</li>
              ))}
            </ul>
          </section>
        ))}
        <Link to="/" className={styles.back}>
          {da.parents.back}
        </Link>
      </Card>
    </SkyPage>
  );
}
